// extracted by mini-css-extract-plugin
export default {"heroHeader":"BurmeseRuby_heroHeader__65pjI","adj1":"BurmeseRuby_adj1__mcswY","adj2":"BurmeseRuby_adj2__eTd-v","adj3":"BurmeseRuby_adj3__FHZ9I"};